import { makeStyles } from "@material-ui/core";

import palette from "layouts/ThemeProvider/palette";

export default makeStyles(
  (theme) => ({
    root: {
      padding: 12,
      borderRadius: 5,
      border: [1, "solid", theme.palette.secondary.main],
      [theme.breakpoints.up("mobile")]: {
        border: "none",
        padding: 0,
      },
    },
    grid: {
      display: "grid",
      gridRowGap: 13,
      [theme.breakpoints.up("mobile")]: {
        gridRowGap: 16,
      },
      [theme.breakpoints.up("tablet")]: {
        gridRowGap: 25,
      },
    },
    nameGrid: {
      display: "grid",
      gridTemplateColumns: "repeat(2, 1fr)",
      gridColumnGap: 12,
      [theme.breakpoints.up("mobile")]: {
        gridColumnGap: 18,
      },
    },
    cardGrid: {
      display: "grid",
      gridTemplateColumns: "auto 84px",
      gridColumnGap: 12,
      [theme.breakpoints.up("mobile")]: {
        gridColumnGap: 18,
      },
    },
    expireGrid: {
      display: "grid",
      gridTemplateColumns: "1fr 1fr 1.8fr",
      gridColumnGap: 12,
      [theme.breakpoints.up("mobile")]: {
        gridTemplateColumns: "auto 70px 70px 128px",
        gridColumnGap: 18,
      },
    },
    expires: {
      display: "none",
      [theme.breakpoints.up("mobile")]: {
        display: "block",
        textTransform: "uppercase",
        fontSize: theme.typography.pxToRem(11),
        whiteSpace: "no-wrap",
        fontWeight: 800,
        alignSelf: "center",
      },
    },
    "@global .recurly-element": {
      height: 50,
      border: [2, "solid", theme.palette.secondary.main],
      borderRadius: 5,
      background: "rgba(163, 234, 235, 0.2)",
    },
    "@global .recurly-element:hover": {
      borderColor: theme.palette.common.black,
    },
    "@global .recurly-element-focus": {
      borderColor: theme.palette.common.black,
    },
    "@global .recurly-element-invalid": {
      backgroundColor: theme.palette.melon,
      borderColor: theme.palette.flamingo,
    },
    recurlyFieldError: {
      "& .recurly-element": {
        backgroundColor: theme.palette.melon,
        borderColor: theme.palette.flamingo,
      },
    },
    commonError: {
      textTransform: "uppercase",
      fontWeight: 800,
      color: theme.palette.deletion.main,
      marginBottom: 24,
    },
    actions: {
      [theme.breakpoints.up("mobile")]: {
        width: 295,
        margin: [0, "auto"],
      },
    },
    termsOfSale: {
      marginBottom: 20,
    },
    countrySelect: {
      marginBottom: 20,
    },
  }),
  { name: "Payment-Form-Recurly-RecurlyForm" },
);

export const recurlyElementStyle = {
  fontColor: palette.primary.light,
  fontSize: "15px",
  padding: "10px 9px",
  placeholder: {
    color: "rgba(81, 123, 211, 0.42)",
  },
  invalid: {
    fontColor: palette.radicalRed,
  },
};
